import RuleContainer from "@/components/RuleContainer";
import VanillaLayout from "@/layouts/VanillaLayout";
import publicPath from "@/utils/publicPath";
import usePageView from "@/hooks/usePageView";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const TermsPage: NextPage = (): JSX.Element => {
  usePageView();

  return (
    <VanillaLayout title="利用規約">
      <NextSeo
        title="利用規約"
        description="TECTUREの利用規約のページです"
        canonical={publicPath("/terms")}
      />
      <div className="max-w-[640px]">
        <RuleContainer
          date={
            <>
              <p>制定: 2020年6月29日</p>
              <p>改定: 2023年2月8日</p>
              <p>改定: 2023年7月10日</p>
              <p>改定: 2024年2月26日</p>
              <p>改定: 2024年7月24日</p>
            </>
          }
        >
          <p>
            本利用規約（以下「本規約」といいます。）は、tecture株式会社（以下「当社」といいます。）が提供するウェブサイトおよびアプリーケーションソフトウェア「TECTURE」および「TECTURE」を通じて当社が提供するサービス（以下総称して「本サービス」といいます。）の提供条件および当社と建築家、デザイナーその他の本サービスの利用者（利用しようとする者も含みます。以下「ユーザー」といいます。）との間の権利義務関係が定めるものです。本サービスの利用に際しては、本規約および当社が別途定める「TECTURE」プライバシーポリシー（以下「本プライバシーポリシー」といいます。）の全文をお読みいただいたうえで、本規約に同意いただく必要があります。なお、本サービスは当初ウェブサービスとして開始しますが、将来的にスマートフォン用アプリケーション等他の形式でのサービス提供を行う場合は、当該他の形式におけるサービスも「本サービス」として本規約が適用されます。
          </p>

          <section>
            <h2>1.目的</h2>
            <ul>
              <li>
                本サービスは、ユーザーに対し、ユーザーによる空間デザインの事例を他のユーザーと共有することを可能にし、また、ユーザーが本サービス上に登録された空間デザインの事例から家具等に関する情報を検索し、当社所定の家具および建材等（以下「家具等」といいます。）の製造業者（以下「メーカー」といいます。）が本サービスに登録した家具等の製品に関してメーカーと取引する機会を提供することを目的とするプラットフォーム型アプリケーションです。
                <br />
              </li>
              <li>
                本規約に基づき本サービス上でユーザー登録したユーザー（以下「登録ユーザー」といいます。）は、本サービス上で、本件製品およびメーカーの問い合わせ先情報等を取得し、本サービス上の問い合わせ機能を通じてメーカーに対して本件製品について問い合わせをすることができます。
              </li>
              <li>
                本サービスは、将来的に機能の拡張等を行うことがあり、本規約は本サービスの機能の拡張等に伴って変更されることがあります。
              </li>
            </ul>
          </section>

          <section>
            <h2>2.定義</h2>
            <p>
              本規約において使用する以下の用語の意味は、各々以下に定めるとおりとします。
            </p>
            <dl>
              <dt>「本件製品」</dt>
              <dd>メーカーが本サービス上に登録した家具等の製品</dd>
            </dl>
            <dl>
              <dt>「本件情報」</dt>
              <dd>
                本件製品の写真その他製品情報および本件製品の販売に関するメーカーの問い合わせ窓口情報
              </dd>
            </dl>
            <dl>
              <dt>「事例」</dt>
              <dd>空間デザインに関する写真</dd>
            </dl>
            <dl>
              <dt>「コンテンツ」</dt>
              <dd>
                文章、音声、音楽、画像、動画、ソフトウェア、プログラム、ソースコード、データベースその他の情報
              </dd>
            </dl>

            <dl>
              <dt>「知的財産権」</dt>
              <dd>
                著作権、著作隣接権、特許権、実用新案権、意匠権、商標権、不正競争防止法に定める権利その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）
              </dd>
            </dl>
            <dl>
              <dt>「サービス利用契約」</dt>
              <dd>
                本規約を契約条件として当社とユーザーの間で締結される、本サービスの使用に関する契約
              </dd>
            </dl>
            <dl>
              <dt>「反社会的勢力」</dt>
              <dd>
                暴力団（暴力団員による不当な行為の防止等に関する法律（平成３年法律第７７号）第２条第２号に規定する暴力団をいいます。以下同様。）、暴力団員（同条第６号に規定する暴力団員をいいます。）、暴力団関係団体、暴力団関係者、右翼団体、総会屋、社会運動標ぼうゴロまたは特殊知能暴力団、その他これらに準ずる者
              </dd>
            </dl>
            <dl>
              <dt>「チーム」</dt>
              <dd>
                本サービス内において登録ユーザーが作成し、構成員となる、特定の設計事務所その他当社が認める団体名の表示
              </dd>
            </dl>
            <dl>
              <dt>「サンプルサービス」</dt>
              <dd>
                当社が、ユーザーに対し、各メーカーが提供する建材等のサンプル品（以下「サンプル品」といいます。）の一括配送を行うことを目的とするサービス
              </dd>
            </dl>
            <dl>
              <dt>「サンプル直送サービス」</dt>
              <dd>
                各メーカーが、ユーザーに対し、当社による手配を介さず、サンプル品を直接ユーザーに配送することを目的とするサービス。
              </dd>
            </dl>
          </section>

          <section>
            <h2>3.規約への同意</h2>
            <ul>
              <li>
                ユーザーは、あらかじめ本規約に有効かつ取消不能な同意をしないかぎり、本サービスに登録およびログインし本サービスを使用することができません。
              </li>
              <li>
                本規約への同意は、ユーザーが個人である場合はユーザー本人、ユーザーが法人である場合は当該法人について本サービスの使用にかかる契約を当社と締結する正当な権限を有する者（代表者、役員または従業員に限ります。）が行う必要があります。これらの自然人以外の者は手続を行うことができません。
              </li>
              <li>
                本サービスについて本規約のほかにプライバシーポリシー、個別の利用規約やガイドライン等が存在し、あるいは追加された場合は、ユーザーは本サービスの使用にあたって当該利用規約等にも従う必要があります。
              </li>
            </ul>
            <p></p>
          </section>

          <section>
            <h2>4.規約の変更</h2>
            <ul>
              <li>
                当社は、必要と判断した場合には、本規約を変更することができます。
              </li>
              <li>
                本規約を変更する場合、当社は、本規約を変更する旨および変更後の本規約の内容ならびにその効力発生時期を、可能な限り事前に、本サービス上の公表その他当社所定の方法により、周知し、または登録ユーザーに対して通知します。但し、当社は、法令上、登録ユーザーの同意が必要となる本規約の変更については、別途当社所定の方法で当該登録ユーザーの同意を取得します。
              </li>
              <li>
                ユーザーは前項に基づき公表等された変更後の本規約についてユーザー自身の責任で確認しなければなりません。
              </li>
              <li>
                本規約の変更の公表後、ユーザーが本サービスを利用した場合には、変更後の本規約の内容に同意したものとみなされるものとします。
              </li>
            </ul>
          </section>

          <section>
            <h2>5.アカウント登録</h2>
            <ul>
              <li>
                ユーザーは、本サービスを使用するためには、本規約を遵守することに同意し、かつ当社所定の情報（以下「登録情報」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの使用のためのアカウント登録を申請する必要があります。
              </li>
              <li>
                アカウントの種類は、一般アカウントとPROアカウントの２種類とし、後者については建築家その他当社が定める基準を満たした者のみが登録できるものとします。
              </li>
              <li>
                当社は、当社の基準に従って、第１項に基づく登録の申請に対して登録の可否を判断し、当社が登録を認める場合にはその旨をユーザーに通知します。当社がユーザーに対して本項の通知を行った時点をもって当該ユーザーの登録ユーザーとしての登録は完了したものとします。
              </li>
              <li>
                前項に定める登録の完了時に、サービス利用契約が登録ユーザーと当社の間に成立し、登録ユーザーは本サービスを本規約に従い使用することができるようになります。
              </li>
              <li>
                アカウント登録を希望するユーザーが未成年者、成年被後見人、被保佐人または被補助人のいずれかである場合、法令上必要とされる法定代理人、後見人、保佐人または補助人の同意等を事前に得た上でアカウント登録を申請する必要があります。
              </li>
              <li>
                当社は、ユーザーが、以下の各号のいずれかの事由に該当する場合は、登録（再度の登録を含みます。）を拒否しまたは登録を取り消すことができます。当社は、当該拒否および取消しの理由について一切開示義務を負いません。
                <ul>
                  <li>
                    登録情報の全部または一部につき虚偽、誤記または記載漏れがあった場合
                  </li>
                  <li>
                    未成年者、成年被後見人、被保佐人または被補助人のいずれかであり、法定代理人、後見人、保佐人または補助人の同意等を得ていなかった場合
                  </li>
                  <li>
                    反社会的勢力である、または資金提供その他の行為を通じて反社会的勢力の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力との何らかの交流もしくは関与を行っていると当社が判断した場合
                  </li>
                  <li>
                    過去当社との契約（サービス利用契約を含みますがこれに限りません。）に違反した者またはその関係者であると当社が判断した場合
                  </li>
                  <li>
                    第23条（使用制限・アカウント削除）に定める措置を受けたことがある場合
                  </li>
                  <li>その他、登録を適当でないと当社が判断した場合</li>
                </ul>
              </li>
            </ul>
          </section>

          <section>
            <h2>6.登録情報の変更</h2>
            <p>
              登録ユーザーは、登録情報に変更があった場合、当社の定める方法により当該変更があった登録情報について遅滞なく本サービス上で更新するものとします。
            </p>
          </section>

          <section>
            <h2>7.アカウント</h2>
            <ul>
              <li>
                登録ユーザーは、１ユーザーにつき本サービスのアカウント１個を保有することができます。
              </li>
              <li>
                一般アカウントの登録ユーザー（以下「一般ユーザー」といいます。）は、本サービスのうち当社が認めたサービスのみ利用できるものとします。PROアカウントの登録ユーザー（以下「PROユーザー」といいます。）は、本サービスの全ての機能を利用できるものとします。ただし、当社が特別に指定した場合にはこの限りではありません。
              </li>
              <li>
                登録ユーザーは、自己の責任において、本サービスに関するパスワードおよびユーザーIDを適切に管理および保管するものとし、これを第三者に使用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。
              </li>
              <li>
                登録ユーザーは、自身のアカウントが不正に使用されているまたはその可能性がある場合には、速やかに第30条（連絡方法）に定める連絡先を通じて当社に連絡する義務があります。
              </li>
              <li>
                パスワードまたはユーザーIDの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任は登録ユーザーが負います。
              </li>
            </ul>
          </section>

          <section>
            <h2>8.チーム</h2>
            <ul>
              <li>
                登録ユーザーは、所定の手続を経ることによりチームを作成することができます。これを希望する登録ユーザーは、当社所定の情報（以下「チーム登録情報」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、チーム登録を申請する必要があります。
              </li>
              <li>
                当社は、当社の基準に従って、第１項に基づく登録の申請に対して登録の可否を判断し、当社が登録を認める場合にはその旨をユーザーに通知し、または本サービス上にチームを表示します。
              </li>
              <li>
                チームの表示の編集・削除等は特定の権限をもった登録ユーザーのみが行うことができるものとします。
              </li>
              <li>
                チームの構成員である登録ユーザーは、他の登録ユーザー及び本サービスのユーザーとなっていない者をチームの構成員として招待することができます。その場合、ユーザーとなっていない者については、本利用規約を遵守させるものとします。
              </li>
              <li>
                チームの構成員間で何らかの問題が生じた場合には、構成員間で解決するものとし、当社に損害等を与えないものとします。
              </li>
              <li>
                当社は、ユーザーが、以下の各号のいずれかの事由に該当する場合は、登録（再度の登録を含みます。）を拒否しまたは登録を取り消すことができます。当社は、当該拒否および取消しの理由について一切開示義務を負いません。
                <ul>
                  <li>
                    チーム登録情報の全部または一部につき虚偽、誤記または記載漏れがあった場合
                  </li>
                  <li>
                    チームの登録にあたって、当該団体から必要な権限を付与されていなかったことが判明した場合
                  </li>
                  <li>
                    当該チームが反社会的勢力である、または資金提供その他の行為を通じて反社会的勢力の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力との何らかの交流もしくは関与を行っていると当社が判断した場合
                  </li>
                  <li>
                    当該チームが過去に当社との契約（サービス利用契約を含みますがこれに限りません。）に違反した者またはその関係者であると当社が判断した場合
                  </li>
                  <li>本条項に基づく登録取消しを受けたことがある場合</li>
                  <li>
                    当該チームの表示が商標法違反等の法令違反に該当する場合
                  </li>
                  <li>その他、登録を適当でないと当社が判断した場合</li>
                </ul>
              </li>
            </ul>
          </section>

          <section>
            <h2>9.使用環境</h2>
            <ul>
              <li>
                ユーザーは、本サービスを使用、ダウンロードまたはインストールする場合は、自らの責任と費用において、インターネットに接続するためのあらゆる機器、通信手段、ソフトウェア等を適切に設置および操作しなければなりません。当社は、これらの操作等に対して一切の責任を負いません。
              </li>
              <li>
                ユーザーは、本サービスの使用に際して当社が推奨するスペックおよびバージョンのPC、携帯端末その他の通信機器、ソフトウェア等を自己の責任と費用で準備しなければなりません。
              </li>
            </ul>
          </section>

          <section>
            <h2>10.本サービスの使用</h2>
            <ul>
              <li>
                当社は、登録ユーザーに対し、以下の目的（以下「本目的」といいます。）に限り、本サービスの使用を許諾します。
                <ul>
                  <li>
                    本サービス上での事例および本件製品の検索ならびに本件情報の閲覧
                  </li>
                  <li>
                    本サービスの問い合わせ機能を通じたメーカーに対する本件製品に関する連絡
                  </li>
                  <li>
                    登録ユーザーが空間デザインを実施した事例の本サービス上での投稿
                  </li>
                  <li>サンプルサービスの利用</li>
                </ul>
              </li>
              <li>
                登録ユーザーは、本サービス上の問い合わせ機能を使用して、本件製品についてメーカーに対して問い合わせを行うことができます。登録ユーザーが問い合わせを行った場合、当社はメーカーに対して登録ユーザーが本サービス上で登録した登録ユーザーの連絡先情報を提供し、メーカーは登録ユーザーに対して当該情報を使用してカタログやサンプルの送付その他連絡を行うことができます。ユーザーは当社からメーカーへの当該情報提供およびメーカーからのカタログ等の送付その他連絡があることについて予め同意します。
              </li>
            </ul>
          </section>

          <section>
            <h2>11.サンプルサービスの利用</h2>
            <ul>
              <li>
                登録ユーザーのうちPROユーザーは、当社の運営に係る本サービス上のサンプルサービスを通じて、当社が指定するサンプル品に限り、注文することができます。なお、PROユーザーは当社に対し、当社の定める方法によりサンプル品としての指定をリクエストできる場合がありますが、当社は必ずこれに応じなければならない義務を負うものではありません。
              </li>
              <li>
                PROユーザーが注文できるサンプル品の数量その他の条件は、１メーカーにつき５枚までとし、別途当社が定める規定その他の表示に従うものとします。
              </li>
              <li>
                PROユーザーは、あくまでサンプル品の確認のために本サービスを利用するものとし、サンプル品の転売その他不当な目的のために利用しないものとします。
              </li>
              <li>
                PROユーザーは、本サービスを無償で利用することができます。ただし、特別の定めがある場合にはこの限りではありません。
              </li>
            </ul>
          </section>

          <section>
            <h2>12.サンプルサービスにおける配送・キャンセル等について</h2>
            <ul>
              <li>
                当社は、その運営に係る本サービスを通じてPROユーザーから受けた注文に基づき、PROユーザーに対してサンプル品の配送を行うものとします。
              </li>
              <li>
                サンプル品の出荷については、PROユーザーの注文が平日月曜日から金曜日の午前中までに到達したものについては、最短当日発送とし、金曜日の午後から日曜日までに到達したものについては、次の平日に発送することを原則とします。
              </li>
              <li>
                サンプル品の在庫がなくなってしまった場合には、５営業日程度かかる可能性があることを了承するものとします。
              </li>
              <li>当社は、配送が遅延した場合の責任は負わないものとします。</li>
              <li>
                PROユーザーは、当社による出荷準備・配送後は、当社が別途認める場合でない限り、申込みの撤回、及びサンプル品の返品・交換をできないものとします。但し、サンプル品に明らかな不具合が存在する場合を除きます。
              </li>
              <li>
                当社は、次の各号のいずれかに該当する場合、任意に注文または取引のキャンセル、もしくは取引の中止を行うことができるものとます。
                <ul>
                  <li>
                    PROユーザーが決済手段について適当な使用権限を有していない場合、または当社においてPROユーザーが当該権限を有していることを確認できない場合
                  </li>
                  <li>本契約に違反する場合</li>
                  <li>
                    不正、詐欺その他類似の事態の可能性があると判断される場合
                  </li>
                  <li>その他本サービスが不正に利用されたと当社がみなす場合</li>
                  <li>
                    その他取引のキャンセルまたは中止について合理的な理由がある場合
                  </li>
                </ul>
              </li>
              <li>
                当社がサンプル品の返品等を認めた場合のサンプル品は、破損や汚損のないものに限り、かつ、TECTUREのロゴが入ったシールが貼付してある状態のものに限るものとします。
              </li>
              <li>
                サンプル品の返品等が認められる場合の返送料は、当社が特別に認める場合でない限り、PROユーザーの負担とします。
              </li>
            </ul>
          </section>

          <section>
            <h2>13.サンプル直送サービスの利用</h2>
            <ul>
              <li>
                登録ユーザーのうちPROユーザーは、当社の運営に係る本サービス上のサンプル直送サービスを通じて、各メーカーが指定するサンプル品に限り、注文することができます。
              </li>
              <li>
                PROユーザーが注文できるサンプル品の内容、数量その他の条件は、各メーカーが定める規定その他の表示に従うものとします。サンプル品の配送期間、返品・交換その他の条件も各メーカーの定めるところによるものとします。
              </li>
              <li>
                PROユーザーは、サンプル直送サービスを利用する場合、当社が各メーカーに対して、PROユーザーの個人情報を含む情報を提供することについて、予め同意するものとします。
              </li>
              <li>
                PROユーザーは、サンプル直送サービスが各メーカーとPROユーザー間の直接の契約であり、当社は何らの責任も負わないことを確認したうえで、当該サービスを利用するものとします。当該サービスの利用に関して何らかの紛争が生じた場合でも、各メーカーとPROユーザー間で解決するものとします。
              </li>
              <li>
                PROユーザーは、あくまでサンプル品の確認のために本サービスを利用するものとし、サンプル品の転売その他不当な目的のために利用しないものとします。
              </li>
              <li>
                当社は、次の各号のいずれかに該当する場合、サンプル直送サービスの注文または取引のキャンセル、もしくは取引の中止を行うことができるものとます。
                <ul>
                  <li>PROユーザーが各メーカーの定める条件等に従わない場合</li>
                  <li>本契約に違反する場合</li>
                  <li>
                    不正、詐欺その他類似の事態の可能性があると判断される場合
                  </li>
                  <li>その他本サービスが不正に利用されたと当社がみなす場合</li>
                  <li>
                    その他取引のキャンセルまたは中止について合理的な理由がある場合
                  </li>
                </ul>
              </li>
            </ul>
          </section>

          <section>
            <h2>14.使用期間</h2>
            <p>
              登録ユーザーの本サービスの使用期間は、第5条に基づき登録ユーザーとしてのアカウント登録が完了した日から登録ユーザーが本サービスを退会しもしくはアカウント登録を削除される日、サービス利用契約が解除される日または当社が本サービスの提供を終了する日のうち最も早い日までとします。
            </p>
          </section>

          <section>
            <h2>15.本サービス提供の停止等</h2>
            <ul>
              <li>
                当社は、以下のいずれかに該当する場合には、登録ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。
                <ul>
                  <li>
                    本サービスに関するシステムその他当社のシステムの点検または保守作業を緊急に行う場合
                  </li>
                  <li>
                    システム、コンピューター、通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング等により本サービスの運営ができなくなった場合
                  </li>
                  <li>
                    地震、台風、津波その他の天変地異、戦争、暴動、内乱、テロ行為、重大な疾病（感染症の発生等を含む。）、法令もしくは規則の制定もしくは改廃、公権力による命令もしくは処分その他の政府による行為（感染症に対する対策実施その他強制力を伴わない要請等を含みます。）、争議行為、輸送機関もしくは通信回線等の事故、その他不可抗力により本サービスの運営ができなくなった場合（政府等により要請に応じて自主休業等をする場合を含みます。）
                  </li>
                  <li>その他、当社が停止または中断を必要と判断した場合</li>
                </ul>
              </li>

              <li>
                当社は、当社の判断により、本サービスを全部または一部終了し、本サービスの内容を全部または一部変更し、または本サービスについてのサポートを終了することができます。この場合、当社は登録ユーザーに事前に通知するものとします。
              </li>

              <li>
                当社は、前2項の措置によって、登録ユーザーが被った損害について、本規約に特別の明示的な定めがない限り、一切の責任を負いません。
              </li>
            </ul>
          </section>

          <section>
            <h2>16.知的財産権</h2>
            <ul>
              <li>
                本サービスに関連する一切のコンテンツ（本件情報を含みます。以下「本コンテンツ」といいます。）に知的財産権その他一切の権利は、本規約に明示的に規定する場合を除き、全て当社または当社に対し本コンテンツの利用を許諾した正当な権限を有する第三者に帰属します。
              </li>

              <li>
                当社は、登録ユーザーに対し、本目的の達成に必要な範囲で本コンテンツの利用を許諾します。
              </li>
            </ul>
          </section>

          <section>
            <h2>17.事例の投稿および利用許諾</h2>
            <ul>
              <li>
                登録ユーザーのうちPROユーザーは、事例その他当社が認めた内容を本サービス上で投稿できます。その場合、当該投稿時点をもって、当社に対し、本サービスおよび本サービスに関連する当社の事業において、事例またはその複製物もしくは翻案物を、本サービスの提供、登録ユーザーのための広報活動、コンテンツ紹介、及び当社の広報活動（ただし、いわゆる「写り込み」の限度に限るものとします。）のために必要かつ適切な限度において、複製し、改変し（本件製品および本件情報を事例に紐付けることも含みます。）、公衆送信し（送信可能化を含みます。）、または展示することを許諾するものとします（この許諾には、上記目的のために必要な限度における第三者に対する再許諾も含みます。なお、ユーザーの退会等によりサービス利用契約が終了した場合であっても、本条に基づく許諾は有効に存続します。）。当社がその他の目的で事例等を複製等する必要がある場合には、事前にPROユーザーと協議のうえ、PROユーザーの許諾を得てから複製等するものとします。
              </li>

              <li>
                PROユーザーは、投稿した事例について、著作者人格権を当社または当社の許諾する第三者に対して行使しないものとします。
              </li>

              <li>
                PROユーザーは、事例の投稿にあたって、あらかじめ、当該事例の投稿、本サービス上での表示、当該事例のクレジット表記方法および内容ならびに第1項に基づく事例の利用について必要となる一切の許諾を、PROユーザーのクライアント、カメラマンその他の当該事例の全部または一部について正当な権利を有する第三者から取得する義務を負います。
              </li>

              <li>
                PROユーザーは、事例の投稿にあたって、当社に対し、当該事例の投稿、本サービス上での表示、第1項に基づく事例の利用が、第三者の知的財産権、肖像権、プライバシー権、パブリシティ権その他の権利を侵害しないことを保証します。
              </li>

              <li>
                当社または当社の許諾した者による事例の利用に関連して第三者から権利侵害等のクレームがあり、または訴訟提起等があった場合は、PROユーザーは、自己の責任と費用負担において対処する義務を負います。また、この場合において、当社または当社の許諾した者に損害が発生した場合は、登録ユーザーは当該損害を賠償する義務を負います。但し、当社または当社の許諾した者に事例の利用に関して故意または重大な過失があった場合はこの限りではありません。
              </li>
            </ul>
          </section>

          <section>
            <h2>18.本件情報の使用</h2>
            <ul>
              <li>
                登録ユーザーのうち一般ユーザーは、本件情報について閲覧その他当社が認めた方法でのみ使用することができます。
              </li>

              <li>
                登録ユーザーのうちPROユーザーは、本件情報を、本サービスのお問い合わせ機能その他当社が指定する方法により本件製品についてメーカーに連絡をする目的でのみ使用することができます。登録ユーザーは、本サービスを介さずメーカーに連絡し、製品に関する取引を行う目的で本件情報を使用してはなりません。
              </li>

              <li>
                登録ユーザーは、自己の責任と費用負担において本件情報を使用するものとします。
              </li>

              <li>
                当社は、本サービスを提供することによって、登録ユーザーが当事者となるいかなる契約締結についても代理、媒介、取次その他一切の契約に関連する行為を行うものではありません。登録ユーザーは、メーカーとの間で本件製品を含む家具等の購入にかかる契約締結その他一切の取引行為を実施する場合は、自己の責任と費用負担において実施するものとします。
              </li>
            </ul>
          </section>

          <section>
            <h2>19.秘密保持義務</h2>
            <ul>
              <li>
                本規約において「秘密情報」とは、本サービスの使用に関連して当社がユーザーに対して開示する一切の情報をいいます。但し、次の各号に掲げるものを除きます。なお、本件情報は「秘密情報」に含みます。
                <ul>
                  <li>開示の時に公知であった情報。</li>
                  <li>
                    開示の後、メーカーの秘密保持義務違反によらずに公知となった情報。
                  </li>
                  <li>登録ユーザーが開示の時に既に正当に保有していた情報。</li>
                  <li>
                    登録ユーザーが第三者から秘密保持義務を負うことなく正当に開示を受けた情報。
                  </li>
                </ul>
              </li>

              <li>
                登録ユーザーは、本目的以外の目的で、秘密情報を使用してはなりません。
              </li>

              <li>
                登録ユーザーは、事前の当社の明示的な同意なく、第三者に秘密情報を開示してはなりません。
              </li>

              <li>
                登録ユーザーは、本件情報または当社から別途要求があった秘密情報について、本サービスの使用期間が終了した場合には、当該情報の使用を停止しなければなりません。
              </li>
            </ul>
          </section>

          <section>
            <h2>20.ユーザー情報の取扱い</h2>
            <p>
              当社によるユーザーの情報の取扱いについては、本プライバシーポリシーの定めによります。当社は、登録ユーザーがサンプルサービスを利用した場合、当該サンプル品に係るメーカー等に対して、そのユーザーに対する営業等の利用に供する目的で、ユーザーの個人情報を含む連絡先等の情報を提供することがあります。ユーザーは、予めこれに同意するものとします。
            </p>
          </section>

          <section>
            <h2>21.反社会的勢力の排除</h2>
            <ul>
              <li>
                登録ユーザーは、当社に対して、登録ユーザーが本規約に同意した日および将来にわたり、自己または自己の役員および従業員が反社会的勢力に該当しないことを表明し、保証します。
              </li>

              <li>
                当社は、合理的理由に基づき登録ユーザーが次の各号に該当すると判断した場合、何らの催告なしにサービス利用契約の全部または一部を解除することができるものとします。
                <ul>
                  <li>
                    反社会的勢力である場合、または反社会的勢力であった場合
                  </li>

                  <li>
                    自らまたは第三者を利用して、当社に対して以下の行為を行った場合
                    <ul>
                      <li>違法なあるいは相当性を欠く不当な要求</li>
                      <li>
                        有形力の行使に限定しない示威行為などを含む暴力行為
                      </li>
                      <li>情報誌の購買など執拗に取引を強要する行為</li>
                      <li>被害者団体など属性の偽装による相手方への要求行為</li>
                      <li>
                        その他「暴力団員による不当な行為の防止等に関する法律」で禁止されている行為
                      </li>
                    </ul>
                  </li>

                  <li>
                    当社に対して、自身が反社会的勢力である、または、関係者である旨を伝えるなどした場合
                  </li>

                  <li>第1項の表明保証に違反した場合</li>
                </ul>
              </li>

              <li>
                当社は、前項によりサービス利用契約を解除したことにより登録ユーザーに損害が生じたとしても、一切の損害賠償を負わないものとします。
              </li>
            </ul>
          </section>

          <section>
            <h2>22.禁止事項</h2>
            <p>
              ユーザーは、本サービスの使用に際してもしくは本コンテンツの利用に際して、以下に定める事項を行ってはなりません。
            </p>
            <ul>
              <li>
                法令、裁判所の判決、決定もしくは命令または法令上拘束力のある行政措置に違反する行為
              </li>
              <li>公の秩序または善良の風俗を害するおそれのある行為</li>
              <li>
                当社または第三者の知的財産権、肖像権、名誉権、プライバシー権、その他法令上または契約上の一切の権利を侵害する行為
              </li>
              <li>
                当社または第三者になりすます行為または意図的に虚偽の情報を流布させる行為
              </li>
              <li>
                営業、宣伝、広告、勧誘、その他営利を目的とする行為（当社の認めたものを除きます。）、性行為やわいせつな行為を目的とする行為、他のユーザーまたはメーカーに対する嫌がらせや誹謗中傷を目的とする行為、その他本目的と異なる目的で本サービスを使用する行為
              </li>
              <li>反社会的勢力に対する利益供与その他の協力行為</li>
              <li>
                本規約で明示的に許諾された場合を除いて、本コンテンツを複製し、転載しまたは転用する行為
              </li>
              <li>
                本件情報、他人の個人情報、登録情報、使用履歴情報などを、不正に収集、開示または提供する行為
              </li>

              <li>
                本サービスに使用されている技術・ノウハウについて、逆アセンブル、逆コンパイルおよびリバースエンジニアリング等をする行為
              </li>
              <li>
                技術的手段を使用して本サービスを不正に操作する行為、本サービスの不具合を意図的に使用する行為、同様の質問を必要以上に繰り返す等、当社に対し不当な問い合わせまたは要求をする行為、その他当社による本サービスの提供または他のユーザーまたはメーカーによる本サービスの使用を妨害し、これらに支障を与える行為
              </li>
              <li>
                本規約に基づくライセンスに違反する本サービスの使用行為その他本規約に違反する行為
              </li>
              <li>
                不当な目的でサンプルサービスのサンプル品の購入を申し込むことをしたと当社が判断した場合
              </li>
              <li>
                正当な理由なくサンプルサービスのサンプル品を受け取らなかった場合
              </li>
              <li>
                正当な理由なくサンプルサービスのサンプル品の返品等をした場合
              </li>
              <li>
                上記（1）から（14）のいずれかに該当する行為を援助または助長する行為
              </li>
              <li>その他、当社が不適当と判断した行為</li>
            </ul>
          </section>

          <section>
            <h2>23.使用制限・アカウント削除</h2>
            <ul>
              <li>
                当社は、登録ユーザーが第22条（禁止事項）各号に掲げる行為のうちいずれか一つでも行ったと当社が判断した場合、その程度に応じて、サービス利用契約を何らの催告を要せず解除し、当該登録ユーザーに対する本サービスまたは本サービスに関するサポートの提供を一時停止もしくは廃止し、または登録ユーザーのアカウント登録を削除することがあります。
              </li>
              <li>
                当社は、当社が本条に基づいて実施した措置に関連して登録ユーザーまたは第三者に発生した損害について、本規約に特別の明示的な定めがない限り、一切賠償する責任を負いません。
              </li>
              <li>
                第1項に基づくアカウント登録の削除にあたり、当社に対して負っている債務がある場合は、登録ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
              </li>
            </ul>
          </section>

          <section>
            <h2>24.退会</h2>
            <ul>
              <li>
                登録ユーザーは、退会を希望する場合は、第30条（連絡方法）第2項に定めるメールアドレス宛にその旨ご連絡いただき、当社所定の手続が完了した場合、本サービスから退会することができます。
              </li>
              <li>
                退会にあたり、当社に対して負っている債務がある場合は、登録ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
              </li>
            </ul>
          </section>

          <section>
            <h2>25.サービス利用契約終了およびその後の措置</h2>
            <ul>
              <li>
                サービス利用契約は、当社による本サービス提供の終了、登録ユーザーのアカウント登録削除もしくは退会または本規約に定める解除もしくは期間満了により終了します。
              </li>
              <li>
                サービス利用契約が終了した場合であっても、第15条(本サービス提供の停止等)第3項、第17条（事例の投稿および利用許諾）、第18条（本件情報の使用）、第19条（秘密保持義務）、第20条（ユーザー情報の取扱い）、第21条（反社会的勢力の排除）第3項、第22条（使用制限・アカウント削除）第2項および第3項、第24条（退会）第2項、本項、第26条（免責）、第27条（権利義務の譲渡等）、第28条（分離可能性）ならびに第29条（準拠法・裁判管轄）の定めは有効に存続します。
              </li>
            </ul>
          </section>

          <section>
            <h2>26.免責</h2>
            <ul>
              <li>
                当社は、本サービスまたは本コンテンツが、ユーザーの特定の目的に適合すること、ユーザーの期待する機能、商品的価値、安全性、信頼性、完全性、有効性、正確性もしくは有用性を有すること、ユーザーによる本サービスの使用がユーザーに適用のある法令に適合すること、継続的に使用できること、およびセキュリティなどに関する欠陥、エラー、バグその他不具合が生じないことについて、明示または黙示を問わず何ら保証するものではありません。
              </li>
              <li>
                当社は、本サービスに起因してユーザーまたは第三者に生じたあらゆる損害について一切の責任を負いません。
              </li>
              <li>
                前各項または本規約の他の条項における当社の責任を免除する条項にかかわらず、サービス利用契約が消費者契約法に定める消費者契約となる場合、当該消費者契約に関する当社の登録ユーザーに対する損害賠償債務との関係では、当該責任免除に関する定めは、適用されません。
              </li>
              <li>
                前項の定めにかかわらず、前項に定める場合において、当社が登録ユーザーに対し負う損害賠償責任は、当該登録ユーザーに現実に生じた通常かつ直接の範囲の損害の範囲内（逸失利益その他特別の事情によって生じた損害は除きます。）とし、かつ、その損害賠償金額は、当社の故意または重大な過失による場合を除き、1000円を上限とします
              </li>
            </ul>
          </section>

          <section>
            <h2>27.権利義務の譲渡等</h2>
            <ul>
              <li>
                登録ユーザーは、サービス利用契約上の地位または権利もしくは義務を、本規約に明示的な別段の定めのない限り、当社の書面による事前の承諾なく、第三者（他のユーザーを含みます。）に譲渡し、または担保に供する（以下「譲渡等」といいます。）ことはできません。
              </li>
              <li>
                万一、譲渡等によって権利を取得したと主張する第三者から当社が履行の請求をされた場合、当該第三者に対して当社が履行を拒否した場合その他当該第三者と当社の間で紛争が発生した場合に、当社が当該第三者に支払った金額または当社に発生する損害もしくは費用について、当該譲渡等を行った登録ユーザーは、当該金額を当社に補填し、当該損害を賠償し費用を負担する義務を負います。
              </li>
              <li>
                当社は、本サービスにかかる事業を第三者に譲渡した場合、または会社分割、合併等の組織再編その他事業が移転するあらゆる取引があった場合（以下「事業譲渡等」といいます。）は、サービス利用契約上の地位、権利および義務ならびにユーザーから取得した情報を、当該事業譲渡等の譲受人等相手方に譲渡することができます。ユーザーは、当該事業譲渡等について本項においてあらかじめ同意したものとします。
              </li>
            </ul>
          </section>

          <section>
            <h2>28.分離可能性</h2>
            <p>
              本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定および一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
            </p>
          </section>

          <section>
            <h2>29.準拠法・裁判管轄</h2>
            <ul>
              <li>本規約は日本法に従って解釈されます。</li>
              <li>
                本規約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              </li>
            </ul>
          </section>

          <section>
            <h2>30.連絡方法</h2>
            <ul>
              <li>
                本サービスに関する当社から登録ユーザーへの連絡は、本サービス上の適宜の場所への掲示その他、当社が適当と判断する方法により行います。
              </li>
              <li>
                本サービスに関する登録ユーザーから当社への連絡は、本サービス上の適宜の場所に設置するお問い合わせフォームの送信または以下のメールアドレスを含む当社が指定する方法により行っていただきます。
                <br />
                <a href="mailto:support@tecture.jp">support@tecture.jp</a>
              </li>
            </ul>
          </section>
        </RuleContainer>
      </div>
    </VanillaLayout>
  );
};

export default TermsPage;
